import styled from 'styled-components'

export const ItemContainer = styled.div<{ hexColor: string }>`
  height: 100px;
  border-left: 2px solid ${(props) => props.hexColor};
  ${(props) => props.theme.container};
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 10px 12px 10px 16px;
`
export const IconContainer = styled.div<{ hexColor: string }>`
  width: 32px;
  height: 32px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.hexColor}20;
  border-radius: 5px;

  svg {
    path {
      stroke: ${(props) => props.hexColor};
    }
  }
`

export const CountContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  color: ${(props) => props.theme.textColor};
`
